import React, { lazy, Suspense } from 'react';
import LoadingSpinner from '@/components/common/ui/LoadingSpinner';
import clsx from 'clsx';
import { Outlet, useLocation } from 'react-router-dom';
import { useMediaMetricsRouteCache } from '@/hooks/useMediaMetricsRouteCache';
import { useNavigationStart } from '@/hooks/useFirstChartMark';

const MediaMetricsViewLazy = lazy(() => import('@/views/MediaMetricsView'));

const LayoutMain: React.FC = () => {
  const location = useLocation();
  useNavigationStart(location.pathname);
  const { onMediaMetrics, showMediaMetricsCache } = useMediaMetricsRouteCache(location.pathname);

  return (
    <main className="flex-1 min-h-0 overflow-y-auto">
      <div className="h-full min-h-0">
        {showMediaMetricsCache && (
          <div
            className={clsx('h-full', !onMediaMetrics && 'hidden')}
            aria-hidden={!onMediaMetrics}
          >
            <Suspense fallback={<LoadingSpinner />}>
              <MediaMetricsViewLazy />
            </Suspense>
          </div>
        )}
        <div
          className={clsx('h-full min-h-0', onMediaMetrics && showMediaMetricsCache && 'hidden')}
        >
          <Outlet />
        </div>
      </div>
    </main>
  );
};

export default LayoutMain;
